import React from "react";

import * as S from "../styled";
import { ModalContext } from "../SuccessMessageModal";

function Title(props) {
  return (
    <ModalContext.Consumer>
      {context => <S.ModalTitle {...props} layout={context.layout} />}
    </ModalContext.Consumer>
  );
}

export default Title;
